// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"efff46db","24":"7c3f75d7","154":"b81ccc57","173":"396c6349","453":"e1e0bdc9","482":"5dc3d6b1"}[chunkId] + ".chunk.js";
};